<template>
  <a-modal v-model="visible" :destroyOnClose="true" :maskClosable="false" :title="$t('title.activeReplenishmentPickUp')" centered footer="" width="70%">
    <a-space>
      <a-select v-model="storageRoomId" style="width: 150px" :placeholder="$t('placeholder.pleaseSelectTargetStorageRoom')" @change="search" allow-clear>
        <a-select-option v-for="d in storageRoomData" :key="d.id">{{d.name}}</a-select-option>
      </a-select>
      <vxe-input v-model="itemNo" clearable placeholder="placeholder.itemNo" size="small" type="search" @search-click="search"/>
      <vxe-input v-model="itemName" clearable placeholder="placeholder.itemName" size="small" type="search" @search-click="search"/>
      <vxe-button content="button.confirm" size="mini" status="primary" @click="confirm"/>
      <vxe-button content="button.cancel" size="mini" status="info" @click="cancel"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :radio-config="{trigger: 'row'}"
      :checkbox-config="{trigger: 'row'}"
      :height="height"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column :type="selectType" fixed="left" width="50"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName"/>
      <vxe-column field="pack.specification" title="business.label.specification"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="invQuantity" title="business.label.existingInventory"/>
      <vxe-column field="quantity" title="business.label.sourceInventoryQuantity"/>
      <vxe-column field="inventoryLimit.lowerBound" title="business.label.lowerBound"/>
      <vxe-column field="inventoryLimit.upperBound" title="business.label.upperBound"/>
      <vxe-column field="obtainedQuantity" title="title.replenishmentQuantity"/>
      <vxe-column field="sourceStorageRoom.name" title="business.label.sourceStorageRoom"/>
      <vxe-column field="targetStorageRoom.name" title="business.label.targetStorageRoom"/>
      <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="90"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-modal>
</template>

<script>
import { findAll } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'ActiveReplenishmentModal',
  data() {
    return {
      visible: false,
      data: [],
      show: false,
      loading: false,
      contentSize: 0,
      page: 1,
      size: 10,
      itemName: '',
      itemNo: '',
      storageRoomId: undefined,
      storageRoomData: [],
      args: {},
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.5)
    }
  },
  props: {
    selectType: {
      type: String,
      default: 'checkbox'
    }
  },
  methods: {
    open(args) {
      this.data = []
      this.itemName = ''
      this.itemNo = ''
      this.storageRoomId = undefined
      this.args = args
      this.visible = true
      this.loading = true
      setTimeout(() => {
        this.loadingPreData()
      }, 300)
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    getData() {
      // if (!this.storageRoomId) {
      //   return this.$message.warning('请先选择目的库房')
      // }
      this.loading = true
      let args = {
        'item.no': this.itemNo,
        'item.name': this.itemName,
        'storageRoom.id': this.storageRoomId
      }
      Object.assign(this.args, args)
      findAll('initiativeReplenishInventoryFactory', this.args, this.page, this.size).then((res) => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(() => {
        this.loading = false
      })
    },
    loadingPreData() {
      let promiseArr = []
      if (this.storageRoomData.length === 0) {
        promiseArr.push(new Promise(resolve => {
          findAll('storageRoomFactory', { physical: true }).then(res => {
            if (res.success) {
              this.storageRoomData = res.result
            }
          }).finally(() => {
            resolve()
          })
        }))
      }
      Promise.all(promiseArr).then(() => this.getData())

    },
    search() {
      this.page = 1
      this.getData()
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        let radioRow = this.$refs.table.getRadioRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        selectedRows = this.$refs.table.getCheckboxRecords()
      }
      this.$emit('change', selectedRows, this.record)
      this.visible = false
    },
    cancel() {
      this.visible = false
    }
  }
}
</script>
